// Update the Terms version here whenever the legal text changes.
export const TERMS_AND_CONDITIONS_VERSION = 'v1.0 - March 2026';

export const TERMS_AND_CONDITIONS_PATH = '/terms-and-conditions';
export const PRIVACY_POLICY_PATH = '/privacy-policy';

export const getTermsAcceptancePayload = () => ({
  // Store the accepted Terms revision in a single API field for future auditing.
  terms_version: TERMS_AND_CONDITIONS_VERSION
});
